import type { FCAData } from "@/types/fca";
import { estadoFitoConfig, riscoConfig, statusRevisaoConfig } from "@/config/cta-config";

/**
 * CSV do exemplar: uma linha por vistoria, com os dados do cadastro repetidos
 * em cada linha (sem vistoria, uma linha so com o cadastro).  BOM + ";" para o
 * Excel em portugues abrir com acentos e colunas certas, como o CSV do CTA.
 */
export function exportTreeCsv(data: FCAData): void {
  const blank = (v: string | number | null | undefined) =>
    v === null || v === undefined || v === "—" || v === 0 ? "" : String(v);
  const semValidada = data.fitossanidade.semVistoriaValidada;
  const naoAvaliado = (v: string) => (semValidada ? "Não avaliado" : v);

  const cadastro: [string, string][] = [
    ["Codigo CTA", data.codigoCta],
    ["Especie", blank(data.nomePopular)],
    ["Nome cientifico", blank(data.nomeCientifico)],
    ["Familia", blank(data.dadosBotanicos.familiaBotanica)],
    ["Tipo", blank(data.tipo)],
    ["Status de revisao", statusRevisaoConfig[data.statusRevisao]?.label ?? blank(data.statusRevisao)],
    ["Projeto", blank(data.projetoVinculado)],
    ["Logradouro", blank(data.logradouro)],
    ["Bairro", blank(data.bairro)],
    ["Municipio", [blank(data.municipio), blank(data.uf)].filter(Boolean).join("/")],
    ["Latitude", blank(data.latitude)],
    ["Longitude", blank(data.longitude)],
    ["UTM E (EPSG:31982)", blank(data.utmE)],
    ["UTM N (EPSG:31982)", blank(data.utmN)],
    ["Data de cadastro", blank(data.dataCadastro)],
    ["Estado fitossanitario atual", naoAvaliado(estadoFitoConfig[data.estadoFitossanitario]?.label ?? blank(data.estadoFitossanitario))],
    ["Risco atual", naoAvaliado(riscoConfig[data.classeRisco]?.label ?? blank(data.classeRisco))],
    ["DAP atual (cm)", blank(data.dap)],
    ["Altura atual (m)", blank(data.altura)],
    ["Diametro de copa atual (m)", blank(data.diametroCopa)],
    ["Manejo recomendado", blank(data.manejoRecomendado)],
  ];
  const vistoriaHeader = [
    "Vistoria - data", "Vistoria - tipo", "Vistoria - tecnico", "Vistoria - status", "Vistoria - estado fitossanitario",
    "Vistoria - risco", "Vistoria - DAP (cm)", "Vistoria - altura (m)", "Vistoria - recomendacao", "Vistoria - observacao",
  ];

  const cell = (v: string) => `"${(v ?? "").replace(/"/g, '""')}"`;
  const base = cadastro.map(([, v]) => v);
  const vistorias = data.vistorias.length > 0 ? data.vistorias : [null];
  const rows = vistorias.map((v) =>
    [
      ...base,
      ...(v
        ? [blank(v.data), blank(v.tipo), blank(v.tecnico), blank(v.status), blank(v.estadoFito), blank(v.risco),
          blank(v.dap), blank(v.altura), blank(v.recomendacao), blank(v.observacao)]
        : vistoriaHeader.map(() => "")),
    ].map(cell).join(";"),
  );
  const header = [...cadastro.map(([k]) => k), ...vistoriaHeader].map(cell).join(";");

  const blob = new Blob(["﻿" + [header, ...rows].join("\r\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `exemplar_${data.codigoCta || data.id}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
